import { ProductGridSkeleton } from '../commerce/ProductGrid';
import { Container } from './Container';

/**
 * Suspense fallback for lazily loaded routes.
 *
 * Shows a product-grid skeleton rather than a spinner: most routes are grids,
 * so the placeholder matches the shape of what is about to arrive and the page
 * does not visibly jump when it does.
 */
export function PageLoader() {
  return (
    <Container className="py-12">
      <span role="status" className="sr-only">
        Carregando página…
      </span>
      <ProductGridSkeleton count={8} />
    </Container>
  );
}
